import { type DatabaseFieldType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import { getTextContent } from '../../lib/dom';
import { encodeHtml } from '../../utils';
import type { FieldType } from '../field-types';

const textFieldType: FieldType<DatabaseFieldType.TEXT> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY,
  ],

  isCsvImportSupported: true,

  renderExportView: ({ value }) => encodeHtml(value).replace(/\r|\n|\r\n/g, '<br/>'),

  parseFromHtml: (el) => getTextContent(el),

  getInitialValue: () => '',

  isEmptyValue: ({ value }) => !value,

  isEqualValue: ({ value: value1 }, { value: value2 }) => value1 === value2,

  getStringRepresentation: ({ value }) => value,
};

export default textFieldType;
